"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var lodash_1 = require("lodash");
var react_1 = require("react");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var constants_1 = require("containers/Benchmarks/constants");
var utils_1 = require("../../utils");
var context_1 = require("../context");
var PlanRowAutocomplete_1 = __importDefault(require("./PlanRowAutocomplete"));
var getAvailableFrequencies = function (row, entriesForFrequency, forField, secondaryField) { return row.family && row.tier
    ? constants_1.FREQUENCY_OPTIONS
        .filter(function (fOpt) { return entriesForFrequency.find(function (pP) { return (0, lodash_1.isEqual)(pP[forField], fOpt.value)
        && (!row[secondaryField] || (0, lodash_1.isEqual)(row[secondaryField], pP[secondaryField])); }); })
    : undefined; };
var BillingCycleSelect = function (_a) {
    var _b, _c;
    var item = _a.item;
    var _d = (0, react_1.useContext)(context_1.AnalyserFormContext), updateRow = _d.updateRow, srvPricePlans = _d.srvPricePlans;
    if (!srvPricePlans) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var entriesForFrequency = 'addOn' in item
        ? (_c = (_b = srvPricePlans.addOnPlans) === null || _b === void 0 ? void 0 : _b.filter(function (pP) { return pP.addOn === item.addOn; })) !== null && _c !== void 0 ? _c : []
        : 'family' in item && srvPricePlans.pricingPlans.filter(function (pP) { return pP.family === item.family && pP.tier === item.tier; });
    var availableBillingCycles = getAvailableFrequencies(item, entriesForFrequency || [], 'billingCycle', 'renewalFrequency');
    if (!(availableBillingCycles === null || availableBillingCycles === void 0 ? void 0 : availableBillingCycles.length)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(PlanRowAutocomplete_1.default, { options: availableBillingCycles, label: "Mo / Yr", onChange: function (v) { return updateRow(item.id, __assign(__assign({}, item), { billingCycle: v === null || v === void 0 ? void 0 : v.value })); }, value: item.billingCycle ? (0, utils_1.getCycleOption)(item.billingCycle) : null }));
};
exports.default = BillingCycleSelect;
